import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function fetchData(category) {
  const res = await apiFetch(`${API_BASE}/data/${category}`);
  try {
    const response = await res.json();
    response.data = Array.isArray(response.data) ? response.data : [];
    return response;
  } catch (_error) {
    return { success: false, error: 'Failed to parse response' };
  }
}

// Resolve a record's category from its id.
//
// Alert-reminder emails link to /dashboard?id=42 rather than
// /dashboard?category=HEALTHCARE_INFORMATION&id=42, because a URL travels further than the
// email body does -- mail gateways log it, link-safety services pre-fetch it, browser
// history keeps it, a forwarded message carries it intact. The dashboard needs the
// category to open the right view, so it asks for it here instead of reading it out of
// the link.
export async function fetchRecordCategory(recordId) {
  const res = await apiFetch(`${API_BASE}/data/record/${recordId}`);
  try {
    return await res.json();
  } catch (_error) {
    return { success: false, error: 'Failed to parse response' };
  }
}

export async function saveData(category, title, content, alertDay, alertMonth, alertYear, alertMessage) {
  const body = { category, title, content, alertDay, alertMonth, alertYear, alertMessage };
  const res = await apiFetch(`${API_BASE}/data`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
  return res.json();
}

export async function updateData(id, category, title, content, alertDay, alertMonth, alertYear, alertMessage) {
  const body = { title, category, content, alertDay, alertMonth, alertYear, alertMessage };
  const res = await apiFetch(`${API_BASE}/data/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body)
  });
  return res.json();
}

export async function deleteData(id) {
  const res = await apiFetch(`${API_BASE}/data/${id}`, { method: 'DELETE' });
  return res.json();
}

export async function fetchDataStats() {
  const res = await apiFetch(`${API_BASE}/data/stats`);
  return res.json();
}
